
<div class="{{class}}">
    <div class="col-md-12">
        <ul *ngIf="shouldShowErrors()" class="validation-errors col-md-12" style="font-weight:normal;">
            <li [ngStyle]="{'font-size': errFontSize}" *ngFor="let err of listOfErrors();" style="color: red">{{err}}</li>
        </ul>
    </div>
</div>